"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const pixi_js_1 = require("pixi.js");
const getBitmapText = (text, color, size, maxWidth, maxLines, horizontalAlignment) => {
    const replaced = text.replace(new RegExp("\\*", "gu"), "");
    const bitmapText = new pixi_js_1.BitmapText(replaced, {
        align: horizontalAlignment,
        fontName: "RetroPixels",
        fontSize: size * 16,
        maxWidth,
        tint: Number(`0x${color.substring(1)}`)
    });
    if (bitmapText.textHeight <= size * maxLines * 11 && bitmapText.width <= maxWidth) {
        return bitmapText;
    }
    const indices = [];
    text.split("").forEach((char, key) => {
        if (char === "*") {
            indices.push(key);
        }
    });
    const asterisks = [];
    indices.forEach((index) => {
        const fragment = text.substring(0, index);
        const wordStart = Math.max(0, fragment.lastIndexOf(" "));
        asterisks.push({
            index,
            word: fragment.substring(wordStart)
        });
    });
    const sortedAsterisks = [...asterisks].sort((asterisk1, asterisk2) => {
        const word1BitmapText = new pixi_js_1.BitmapText(asterisk1.word, {
            align: horizontalAlignment,
            fontName: "RetroPixels",
            fontSize: size * 16
        });
        const word2BitmapText = new pixi_js_1.BitmapText(asterisk2.word, {
            align: horizontalAlignment,
            fontName: "RetroPixels",
            fontSize: size * 16
        });
        return word2BitmapText.width - word1BitmapText.width;
    });
    const pieces = text.split("");
    if (sortedAsterisks.length > 0) {
        const asterisk = sortedAsterisks[0];
        pieces.splice(asterisk.index - 1, 1);
    }
    const joined = pieces.join("");
    if (joined === text) {
        throw new Error(`Text "${text}" of max width ${maxWidth} and lines ${maxLines} does not fit.`);
    }
    return getBitmapText(joined, color, size, maxWidth, maxLines, horizontalAlignment);
};
exports.default = getBitmapText;
